import { Component, Input, Output, EventEmitter, OnInit, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';

import { EnumSectionStatus, IQuestionnaireQuestion, IQuestionnaireSection, IQuestionnaireSubSection } from '../questionnaire.model';

@Component({
    selector: 'app-svg-rating',
    standalone: true,
    imports: [
        CommonModule
    ],
    templateUrl: './svg-rating.component.html',
    styleUrls: ['./svg-rating.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class SvgRatingComponent implements OnInit {
    @Input() section: IQuestionnaireSection;
    @Input() subSection: IQuestionnaireSubSection;
    @Input() question: IQuestionnaireQuestion;
    currentRating = 0;
    @Output() ratingChange = new EventEmitter<number>();

    ratings = [1, 2, 3, 4];
    hoverRating = 0;
    
    get isDisalbed() {
        return this.subSection.status == EnumSectionStatus.COMPLETED ? true : false;
    }

    ngOnInit() {
        const answerValue = this.question?.answer?.value;

        if (answerValue !== undefined && answerValue !== null) {
            this.currentRating = parseInt(answerValue);
        }
        else {
            this.currentRating = 0;
        }
    }

    // When user clicks a star
    setRating(value: number) {
        if (this.isDisalbed) {
            return;
        }
        // Don’t allow below 1
        this.currentRating = Math.max(1, value);
        this.ratingChange.emit(this.currentRating);
    }

    // Show preview when hovering
    setHover(value: number) {
        if (this.isDisalbed) {
            return;
        }
        this.hoverRating = value;
    }

    // Reset preview when leaving
    clearHover() {
        if (this.isDisalbed) {
            return;
        }
        this.hoverRating = 0;
    }
}
